const generateSectionKey = (section) =>
  section
    .replace(/[^a-zA-Z\d]/g, '')
    .split(' ')
    .join('_')
    .toLowerCase();

export default generateSectionKey;
